<template>
  <div class="d-flex space-between">
    <v-autocomplete
      ref="moreAutoComplete"
      v-model="selectedData"
      :items="items"
      :search-input.sync="search"
      :placeholder="placeholder"
      :item-text="itemText"
      :item-value="itemValue"
      :background-color="backgroundColor"
      hide-details
      hide-no-data
      clearable
      dense
      filled
      light
      @keypress.enter.prevent="fetchData"
    >
      <template slot="item" slot-scope="{ item }">
        <v-list-item-avatar>
          <v-avatar size="30">
            <v-img v-if="item.logo" :src="item.logo" cover></v-img>
            <v-icon v-else v-text="$getIcon('mdiAccountCircle')"></v-icon>
          </v-avatar>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>
            {{ item.name }}
          </v-list-item-title>
          <v-list-item-subtitle
            v-if="item.email"
            v-text="item.email"
          ></v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </v-autocomplete>
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: [Number, String, Array, Object],
      default: undefined
    },
    endpoint: {
      type: String,
      default: ""
    },
    itemText: {
      type: String,
      required: true
    },
    itemValue: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: ""
    },
    backgroundColor: {
      type: String,
      default: ""
    },
    loadAtEnterOnly: {
      type: Boolean,
      deafult: false
    }
  },
  data() {
    return {
      items: [],
      selectedData: null,
      search: "",
      loading: false
    };
  },
  watch: {
    search(newVal) {
      if (newVal.length > 1 && !this.loadAtEnterOnly) {
        this.fetchData();
      }
    },
    selectedData(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    fetchData() {
      if (this.search) {
        this.loading = true;
        this.$axios
          .get(this.endpoint, {
            params: {
              search: this.search
            }
          })
          .then(({ data }) => {
            this.items = data;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  }
};
</script>
